import React from 'react';
import PageHeader from '../../utils/PageHeader/PageHeader';
import PageTitle from '../../utils/PageTitle';

export default function () {
    return (<>
        <PageTitle title="Disclaimer" />
		<PageHeader title="Disclaimer" />
    </>);
}